module.exports = __webpack_public_path__ + "img/heart-red-fill.fbee0342.svg";